const canceledStyles = [
    { text: 'Gray text', value: 'canceled' },
    { text: 'Red text, striked through', value: 'canceledRed' }
]

export default canceledStyles
